"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NOVA_SENHA = exports.CONFIRMACAO_SENHA = void 0;
var NOVA_SENHA = "novaSenha";
exports.NOVA_SENHA = NOVA_SENHA;
var CONFIRMACAO_SENHA = "confirmacaoSenha";
exports.CONFIRMACAO_SENHA = CONFIRMACAO_SENHA;